import React, { useEffect, useState, useContext } from "react";
import expertDefaultImg from "../../images/expert-default.png";
import ProjectScreeningQueAns from "./ProjectScreeningQueAns";
import ExAvailabilityComment from "./ExAvailabilityComment";
import ComposeNewEmail from "../EmailUI/ComposeNewEmail";
import { UrlContext } from "../../contexts/UrlContext";

export default function RequestRow({
  data,
  project_id,
  questions,
  project_name,
  backupData,
  setBackupData,
  setAcceptRequest,
  setRejectRequest,
  setExpertName,
  setRequestSelected,
  request,
  screeningQuestions,
  projectType,
}) {
  const [showComment, setShowComment] = useState(false);
  const mediaLink = "https://media.licdn.com/";
  const databaseLink = "https://images.expertpowerhouse.com";
  const [exObject, setExObject] = useState({
    expertName: "",
    expertLink: "",
    expertEmail: "",
  });

  const [openEmail, setOpenEmail] = useState(false);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const { API_URL, URI } = useContext(UrlContext);
  const [defaultEmailTemplates, setDefaultEmailTemplates] = useState([]);

  useEffect(() => {
    if (data) {
      setExObject({
        expertName: data.name,
        expertLink: data.link,
        expertEmail: data.email,
      });
    }
  }, [data]);

  // Function to get email template for sending email
  const getEmailTemplate = async () => {
    setLoadingPopup(true);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}get-email-template`;
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        projectID: project_id,
        expertID: data.ID,
        projectName: project_name,
        expertName: data.name,
        expertEmail: data.email,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setDefaultEmailTemplates(data.templates);
          setLoadingPopup(false);
          setOpenEmail(true);
        } else {
          console.error("Error saving invitation log:", data.msg);
          setLoadingPopup(false);
        }
      });
  };

  return (
    <div className="prjdetails-table-row" style={{ margin: "0" }}>
      <div className="prjdetails-row-top">
        <div className="row-left-top-div">
          <div className="con-image-div">
            <a
              href={`/app/ExpertDetails/${data?.ID}`}
              className="prjdetails-eph-profile"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className={`prjdetails-con-img `}
                src={
                  data?.profilePicture?.slice(0, 24) == mediaLink
                    ? data?.profilePicture
                    : `${databaseLink}${data?.profilePicture}`
                }
                alt=""
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = expertDefaultImg;
                }}
              />
            </a>
            <div className="name-con-expert-div">
              <a
                className="prjdetails-con-name"
                href={data?.link}
                target="_blank"
                rel="noreferrer"
              >
                {data?.name}
              </a>
              <div className="position-relative">
                <select
                  className="prjdetails-select-con no-select"
                  value={data?.cons_exp}
                  style={{ marginRight: "20px" }}
                >
                  <option value={data?.cons_exp}>{data?.cons_exp}</option>
                </select>
              </div>
            </div>
          </div>
          <div className="left-bottom-phone position-relative">
            <i
              className="fa-regular fa-envelope"
              style={{ marginRight: "1px", fontSize: "16px" }}
            />
            <input placeholder="Email" value={data?.email} />
          </div>
          <div className="left-bottom-phone position-relative">
            <i className="fa-solid fa-phone" style={{ marginRight: "2px" }} />
            <input placeholder="Phone number" value={data?.phone_n} />
          </div>

          <div className="left-bottom-hourly position-relative flex flex-col">
            <div className="flex flex-row items-center gap-2">
              <i className="fa-solid fa-money-bill-1" title="Hourly rate" />
              <p className="text-[#365561]">{data?.hourly_rate}</p>
            </div>
            <p className="text-xs text-[#365561]">
              {projectType === "exp" &&
                data?.expectedRate &&
                `Expects: ${data?.expectedRate}`}
            </p>
          </div>
          <div className="left-bottom-daily position-relative flex flex-col">
            <div className="flex flex-row items-center gap-2">
              <i className="fa-solid fa-money-bill" title="Daily rate" />
              <p className="text-[#365561]">{data?.daily_rate}</p>
            </div>
            <p className="text-xs text-gray-400">
              {projectType !== "exp" &&
                data?.expectedRate &&
                `Expects: ${data?.expectedRate}`}
            </p>
          </div>
        </div>
        <div style={{ display: "inline-flex" }}>
          <div className="prjdetails-panel prjdetails-third-panel">
            <div className="prjdetails-panel-body pn">
              <table className="table prjdetails-second-section mbn tc-icon-1 tc-med-2 tc-bold-last">
                <tbody>
                  <tr>
                    <td className="position-relative">
                      <textarea
                        placeholder="Summary"
                        title="Summary"
                        value={data?.summ}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="position-relative">
                      <textarea
                        placeholder="Experience"
                        title="Experience"
                        value={data?.experience}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="position-relative">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: questions,
                        }}
                        className="project-expert-selfsummary"
                      ></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="prjdetails-panel prjdetails-action-btn">
          <div className="prjdetails-btns-div position-relative ml-4 mr-1">
            <ProjectScreeningQueAns
              data={{ expert: data }}
              expert_id={data?.ID}
              project_id={project_id}
              screeningQuestions={screeningQuestions}
            />
          </div>
        </div>

        <div className="prjdetails-panel prjdetails-action-btn">
          <div className="prjdetails-btns-div position-relative">
            <button
              className="btn"
              style={{ width: "130px" }}
              onClick={() => getEmailTemplate()}
            >
              <i
                className="fa-regular fa-envelope"
                title="Click to Email"
              />{" "}
              Email
            </button>
            {loadingPopup && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
                <i class="fa-solid fa-spinner fa-spin text-9xl text-[#365561]" />
              </div>
            )}
          </div>
        </div>

        <div className="prjdetails-panel prjdetails-action-btn">
          <div className="prjdetails-btns-div position-relative">
            <button
              className="btn addToPjButton"
              onClick={() => {
                setRejectRequest(true);
                setExpertName(data);
                setRequestSelected(request);
              }}
            >
              Reject
              <i className="fa-solid fa-user-minus ml-2" />
            </button>
            <button
              className="btn addToPjButton"
              onClick={() => {
                setAcceptRequest(true);
                setExpertName(data);
                setRequestSelected(request);
              }}
            >
              Accept
              <i className="fa-solid fa-user-plus ml-2" />
            </button>
          </div>
        </div>
      </div>

      <div className="prjdetails-row-bottom">
        <div style={{ float: "left", marginLeft: "11px" }}>
          {showComment && (
            <ExAvailabilityComment
              comment={data?.Available_comment}
              expert_id={data?.ID}
              backupData={backupData}
              setBackupData={setBackupData}
              setShowComment={setShowComment}
            />
          )}
          <div className="topCon-available-date">
            <i
              className="calender-icon fa-regular fa-calendar-days"
              style={{ marginRight: "11px" }}
            ></i>
            <label>Availability</label>
            <i
              className={
                data?.Available_comment
                  ? "comment-icon fa-regular fa-comment-dots"
                  : "comment-icon comment-empty fa-regular fa-comment-dots"
              }
              onClick={() => setShowComment(!showComment)}
              title="Click to see comment"
              style={{ left: "98px" }}
            ></i>
            <input
              type="date"
              style={{ height: "26px" }}
              value={new Date(data?.Available_from).toISOString().slice(0, 10)}
            />
          </div>
        </div>
      </div>
      {openEmail && (
        <ComposeNewEmail
          onClose={() => setOpenEmail(false)}
          defaultTo={[data?.email]}
          defaultTemplates={defaultEmailTemplates}
          callingFrom={'Email'}
          projectID={project_id}
        />
      )}
    </div>
  );
}